<div class="ui-g">
  <div class="ui-g-offset-3 ui-g-9">
    <h3 class="text-left m-t-0">{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.TITLE' | translate }}</h3>
  </div>
</div>

<div class="ui-g" *ngFor="let appointee of appointees">
  <div class="ui-g-3 text-right" [ngClass]="(appointee?.official===true)?'official-contact-modify':''">
    <b *ngIf="appointee.directoryTitle">{{appointee.directoryTitle }}</b>
    <b *ngIf="!appointee.directoryTitle">{{appointee.standardTitle.name }}</b>
  </div>
  <div class="ui-g-9">
    <a [routerLink]="['/persons', appointee.consultant.id, 'detail']">
      {{ getFullName(appointee) }}
    </a>
    <i class="fa fa-pen edit-appointment"
       (click)="modify(appointee)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.MODIFY_APPOINTMENT_CONTACT_TOOLTIP' | translate }}">
    </i>
    <i class="fa fa-trash delete-appointment"
       (click)="delete(appointee)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.REMOVE_APPOINTMENT_TOOLTIP' | translate }}">
    </i>
    <i *ngIf="appointee.orderNumber > 0" class="fa fa-angle-up move-appointment"
       (click)="moveAppointmentUp(appointee)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.CHANGE_APPOINTEE_ORDER' | translate }}">
    </i>
    <i *ngIf="appointee.orderNumber < appointees?.length - 1" class="fa fa-angle-down move-appointment"
       (click)="moveAppointmentDown(appointee)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.CHANGE_APPOINTEE_ORDER' | translate }}">
    </i>
  </div>
</div>

<div class="ui-g">
  <div class="ui-g-offset-3 ui-g-9">
    <button pButton
            label="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.ADD_APPOINTMENT_BTN' | translate }}"
            (click)="add()">
    </button>
  </div>
</div>

<wsd-add-organization-appointment (onSave)="onSave($event)">
</wsd-add-organization-appointment>
